var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid is-col-min-15" }, [
    _c("div", { staticClass: "cell" }, [
      _c("article", { staticClass: "box" }, [
        _c("div", { staticClass: "columns is-gapless" }, [
          _c("div", { staticClass: "column" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(" Details "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.innerValue.isNew,
                      expression: "!innerValue.isNew",
                    },
                  ],
                  staticClass: "icon has-text-info tooltip is-tooltip-info",
                  class: [_vm.canChangeReadOnly ? "readonly-pointer" : ""],
                  attrs: {
                    "data-tooltip": _vm.innerValue.readOnly
                      ? "Quote is locked"
                      : "Quote is unlocked",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toogleReadOnly()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "icon mdi",
                    class: [
                      _vm.innerValue.readOnly
                        ? "mdi-lock-outline"
                        : "mdi-lock-open-outline",
                    ],
                  }),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "column is-narrow" }, [
            _c("div", { staticClass: "tags" }, [
              _vm.invoice
                ? _c(
                    "span",
                    { staticClass: "tag is-success is-pulled-right" },
                    [
                      _vm._v(
                        "Inv " +
                          _vm._s(
                            `${_vm.invoice.prefix}${_vm.invoice.invoiceNo}${_vm.invoice.suffix}/${_vm.invoice.invoiceType}`
                          ) +
                          " dated " +
                          _vm._s(
                            _vm.$filters.formatDateLocale(
                              _vm.invoice.invoiceDate,
                              _vm.$userInfo.locale
                            )
                          )
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.excessInvoice
                ? _c(
                    "span",
                    { staticClass: "tag is-success is-pulled-right" },
                    [
                      _vm._v(
                        "Excess Inv " +
                          _vm._s(
                            `${_vm.excessInvoice.prefix}${_vm.excessInvoice.invoiceNo}${_vm.excessInvoice.suffix}/${_vm.excessInvoice.invoiceType}`
                          ) +
                          " dated " +
                          _vm._s(
                            _vm.$filters.formatDateLocale(
                              _vm.excessInvoice.invoiceDate,
                              _vm.$userInfo.locale
                            )
                          )
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Quote No.")]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                staticClass: "input is-static",
                attrs: { type: "text", placeholder: "Quote No.", readonly: "" },
                domProps: {
                  value: `${_vm.innerValue.prefix}${_vm.innerValue.quoteNo}${_vm.innerValue.suffix}`,
                },
              }),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "field is-narrow" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("Quote Date")]),
              _vm.readOnlyView
                ? _c("input", {
                    staticClass: "input is-static",
                    attrs: { readonly: "" },
                    domProps: {
                      value: _vm.$filters.formatDateLocale(
                        _vm.quoteDate,
                        _vm.$userInfo.locale
                      ),
                    },
                  })
                : _c("v-date-picker", {
                    attrs: {
                      "is-dark": _vm.$theme.isDark,
                      masks: _vm.formats,
                      attributes: _vm.attrs,
                      locale: _vm.$userInfo.locale,
                      timezone: _vm.$filters.getIanaTimezone(),
                    },
                    on: { input: _vm.quoteDateInputEvent },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                { staticClass: "control has-icons-left" },
                                [
                                  _c(
                                    "input",
                                    _vm._g(
                                      {
                                        staticClass: "input",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Quote Date",
                                          readonly: "",
                                        },
                                        domProps: { value: inputValue },
                                      },
                                      inputEvents
                                    )
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "icon is-small is-left" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-calendar mdi-18px",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selectedQuoteDate,
                      callback: function ($$v) {
                        _vm.selectedQuoteDate = $$v
                      },
                      expression: "selectedQuoteDate",
                    },
                  }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns mb-0" }, [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "column is-flex is-justify-content-flex-end py-2",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.ntarLtarStatus,
                        expression: "ntarLtarStatus",
                      },
                    ],
                    staticClass: "field",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "tag is-success animate__animated animate__pulse animate__repeat-3 tooltip",
                        attrs: {
                          "data-tooltip": `${_vm.ntarLtarStatus} schedule and times found`,
                        },
                      },
                      [_vm._v(_vm._s(_vm.ntarLtarStatus) + " Hours On")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm.readOnlyView
            ? _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: { value: _vm.vehicle ? _vm.vehicle.rego : "" },
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "control",
                      staticStyle: { "margin-top": "2.5px" },
                    },
                    [
                      _vm.selectedVehicle
                        ? _c("span", { staticClass: "tag is-info is-medium" }, [
                            _vm._v(
                              _vm._s(
                                _vm.vehicle
                                  ? _vm.vehicle.model.name.replace(/ +/g, " ")
                                  : ""
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ])
            : _c("div", { staticClass: "field has-addons" }, [
                _c(
                  "div",
                  { staticClass: "control is-expanded" },
                  [
                    _vm.vehicles
                      ? _c(
                          "multiselect",
                          {
                            class: {
                              "is-danger": _vm.$v.entity.vehicleId.$error,
                            },
                            attrs: {
                              id: "quote-vehicle-multiselect",
                              "deselect-label": "Can't remove this value",
                              "track-by": "vehicleId",
                              label: "rego",
                              placeholder: "Search By Rego...",
                              options: _vm.vehicles,
                              loading: _vm.isVehicleLoading,
                              "internal-search": false,
                              "options-limit": _vm.vehicleFilter.pageSize,
                              searchable: true,
                              "show-labels": false,
                              "allow-empty": false,
                            },
                            on: {
                              select: _vm.selectVehicle,
                              remove: _vm.removeVehicle,
                              "search-change": _vm.getVehicleDropdownFilter,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "singleLabel",
                                  fn: function ({ option }) {
                                    return [
                                      _vm._v(" " + _vm._s(option.rego) + " "),
                                      _vm.selectedVehicle
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tag is-info is-pulled-right",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selectedVehicle.model
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "option",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tag is-pulled-right is-info",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.option.model) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("span", [
                                        _vm._v(_vm._s(props.option.rego)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4226320794
                            ),
                            model: {
                              value: _vm.selectedVehicle,
                              callback: function ($$v) {
                                _vm.selectedVehicle = $$v
                              },
                              expression: "selectedVehicle",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "has-text-danger",
                                attrs: { slot: "noResult" },
                                slot: "noResult",
                              },
                              [_vm._v("Vehicle not found.")]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.$v.entity && _vm.$v.entity.vehicleId.$error
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Vehicle is required."),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button",
                      class: _vm.vehicleButtonClass,
                      on: {
                        click: function ($event) {
                          return _vm.onEditAddVehicle()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", {
                          staticClass: "mdi mdi-24px",
                          class: _vm.vehicleButtonIconClass,
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _vm.readOnlyView
              ? _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Insurer")]),
                  _c("input", {
                    staticClass: "input is-static",
                    attrs: { readonly: "" },
                    domProps: {
                      value: _vm.quoteInsurer ? _vm.quoteInsurer.name : "",
                    },
                  }),
                ])
              : _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Insurer")]),
                  _c("div", { staticClass: "field has-addons" }, [
                    _c(
                      "div",
                      { staticClass: "control is-expanded" },
                      [
                        _vm.insurers
                          ? _c(
                              "multiselect",
                              {
                                class: {
                                  "is-danger": _vm.$v.entity.insurerId.$error,
                                },
                                attrs: {
                                  "deselect-label": "Can't remove this value",
                                  "track-by": "assetId",
                                  label: "assetName",
                                  placeholder: "Search By Name...",
                                  options: _vm.insurers,
                                  loading: _vm.isInsurerLoading,
                                  "internal-search": false,
                                  "options-limit": _vm.insurerFilter.pageSize,
                                  searchable: true,
                                  "show-labels": false,
                                  "allow-empty": false,
                                  disabled:
                                    _vm.innerValue.readOnly || _vm.audanetLock,
                                },
                                on: {
                                  select: _vm.selectInsurer,
                                  remove: _vm.removeInsurer,
                                  "search-change": _vm.getInsurerDropdownFilter,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(props.option.assetName)
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2645691248
                                ),
                                model: {
                                  value: _vm.selectedInsurer,
                                  callback: function ($$v) {
                                    _vm.selectedInsurer = $$v
                                  },
                                  expression: "selectedInsurer",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "has-text-danger",
                                    attrs: { slot: "noResult" },
                                    slot: "noResult",
                                  },
                                  [_vm._v("Insurer not found.")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.$v.entity && _vm.$v.entity.insurerId.$error
                          ? _c("span", { staticClass: "help is-danger" }, [
                              _vm._v("Insurer is required."),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "control is-narrow" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          class: _vm.insurerButtonClass,
                          attrs: {
                            disabled:
                              _vm.innerValue.readOnly || _vm.audanetLock,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onEditAddInsurer()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", {
                              staticClass: "mdi mdi-24px",
                              class: _vm.insurerButtonIconClass,
                            }),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Labour Type")]),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: { value: _vm.innerValue.labourType },
                    }),
                  ])
                : _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerValue.labourType,
                              expression: "innerValue.labourType",
                            },
                          ],
                          attrs: {
                            disabled:
                              _vm.innerValue.readOnly || _vm.audanetLock,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.innerValue,
                                "labourType",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(
                          _vm.labourTimeTypes,
                          function (labourTime, prop) {
                            return _c(
                              "option",
                              { key: prop, domProps: { value: prop } },
                              [_vm._v(_vm._s(labourTime))]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Quoter")]),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static is-capitalized",
                      attrs: { readonly: "" },
                      domProps: { value: _vm.innerValue.quoter },
                    }),
                  ])
                : _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("bulma-autocomplete", {
                        attrs: {
                          placeholder: "Quoter",
                          data: _vm.filteredQuoters,
                          "keep-first": true,
                          loading: false,
                          "class-prop":
                            "is-capitalized" +
                            (!_vm.$v.entity.quoter.$error ? "" : " is-danger"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$v.detailGroup.$touch()
                          },
                        },
                        model: {
                          value: _vm.innerValue.quoter,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "quoter", $$v)
                          },
                          expression: "innerValue.quoter",
                        },
                      }),
                      _vm.$v.entity && _vm.$v.entity.quoter.$error
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("Quoter is required."),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Job Stage")]),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.jobStages?.find(
                          (j) => j.stage === _vm.innerValue.jobStage
                        )?.description,
                      },
                    }),
                  ])
                : _c("div", { staticClass: "control is-expanded" }, [
                    _c("div", { staticClass: "select is-fullwidth" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerValue.jobStage,
                              expression: "innerValue.jobStage",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.innerValue,
                                "jobStage",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(_vm.jobStages, function (jobStage) {
                          return _c(
                            "option",
                            {
                              key: jobStage.stage,
                              domProps: { value: jobStage.stage },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$filters.formatJobStage(
                                      jobStage.enumDescription
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
            ]),
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Method")]),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value:
                          _vm.value.quotingMethod ===
                          _vm.quotingMethodTypes.Hour
                            ? "Hour"
                            : "Dollar",
                      },
                    }),
                  ])
                : _c("div", { staticClass: "control pt-1" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-default p-round p-bigger p-smooth",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.quotingMethod,
                              expression: "value.quotingMethod",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            name: "rd-quotingMethod",
                            disabled:
                              _vm.innerValue.readOnly || _vm.audanetLock,
                          },
                          domProps: {
                            value: "H",
                            checked: _vm._q(_vm.value.quotingMethod, "H"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(_vm.value, "quotingMethod", "H")
                            },
                          },
                        }),
                        _vm._m(1),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-default p-round p-bigger p-smooth",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.quotingMethod,
                              expression: "value.quotingMethod",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            name: "rd-quotingMethod",
                            disabled:
                              _vm.innerValue.readOnly || _vm.audanetLock,
                          },
                          domProps: {
                            value: "D",
                            checked: _vm._q(_vm.value.quotingMethod, "D"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(_vm.value, "quotingMethod", "D")
                            },
                          },
                        }),
                        _vm._m(2),
                      ]
                    ),
                  ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Claim No.")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue.claimNo,
                      expression: "innerValue.claimNo",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  class: { "is-static": _vm.readOnlyView },
                  attrs: {
                    type: "text",
                    placeholder: !_vm.readOnlyView ? "Claim No." : "",
                    disabled: _vm.audanetLock,
                  },
                  domProps: { value: _vm.innerValue.claimNo },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.innerValue, "claimNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Policy No.")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue.policyNo,
                      expression: "innerValue.policyNo",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  class: { "is-static": _vm.readOnlyView },
                  attrs: {
                    type: "text",
                    placeholder: !_vm.readOnlyView ? "Policy No." : "",
                  },
                  domProps: { value: _vm.innerValue.policyNo },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.innerValue, "policyNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Authorised Date"),
                ]),
                _vm.readOnlyView
                  ? _c("div", { staticClass: "control" }, [
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateLocale(
                            _vm.innerValue.authorisedDate,
                            _vm.$userInfo.locale
                          ),
                        },
                      }),
                    ])
                  : _c("v-date-picker", {
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      on: { input: _vm.authorisedDateInputEvent },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field" }, [
                                _c(
                                  "div",
                                  { staticClass: "control has-icons-left" },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Authorised Date",
                                            readonly: "",
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-calendar mdi-18px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.selectedAuthorisedDate,
                        callback: function ($$v) {
                          _vm.selectedAuthorisedDate = $$v
                        },
                        expression: "selectedAuthorisedDate",
                      },
                    }),
              ],
              1
            ),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Assessor")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue.assessorName,
                      expression: "innerValue.assessorName",
                    },
                  ],
                  staticClass: "input is-capitalized",
                  class: { "is-static": _vm.readOnlyView },
                  attrs: {
                    type: "text",
                    placeholder: !_vm.readOnlyView ? "Assessor" : "",
                  },
                  domProps: { value: _vm.innerValue.assessorName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.innerValue,
                        "assessorName",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "is-flex is-justify-content-space-between" },
                [
                  _c("label", { staticClass: "label" }, [_vm._v("Excess")]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-align-items-center is-justify-content-end mb-2",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "pretty-checkbox-label pr-1 is-size-7",
                          attrs: { for: "chk-excessWtihGst" },
                        },
                        [_vm._v("Excess with GST")]
                      ),
                      _c(
                        "div",
                        { staticClass: "pretty p-icon p-round p-smooth m-0" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerValue.excessWithGst,
                                expression: "innerValue.excessWithGst",
                              },
                            ],
                            attrs: {
                              id: "chk-excessWtihGst",
                              type: "checkbox",
                              disabled:
                                _vm.innerValue.readOnly ||
                                _vm.readOnlyView ||
                                _vm.audanetLock,
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.innerValue.excessWithGst
                              )
                                ? _vm._i(_vm.innerValue.excessWithGst, null) >
                                  -1
                                : _vm.innerValue.excessWithGst,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.innerValue.excessWithGst,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.innerValue,
                                        "excessWithGst",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.innerValue,
                                        "excessWithGst",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.innerValue, "excessWithGst", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(3),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatNumber(
                          _vm.excess,
                          _vm.$userInfo.locale
                        ),
                      },
                    }),
                  ])
                : _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          placeholder: "Excess",
                          precision: 2,
                          disabled: _vm.innerValue.readOnly || _vm.audanetLock,
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.calculateExcess()
                          },
                        },
                        model: {
                          value: _vm.excess,
                          callback: function ($$v) {
                            _vm.excess = $$v
                          },
                          expression: "excess",
                        },
                      }),
                    ],
                    1
                  ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Owner's Contribution"),
              ]),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatNumber(
                          _vm.innerValue.ownersContribution,
                          _vm.$userInfo.locale
                        ),
                      },
                    }),
                  ])
                : _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          placeholder: "Owner's Contribution",
                          precision: 2,
                          disabled: _vm.innerValue.readOnly || _vm.audanetLock,
                        },
                        model: {
                          value: _vm.innerValue.ownersContribution,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "ownersContribution", $$v)
                          },
                          expression: "innerValue.ownersContribution",
                        },
                      }),
                    ],
                    1
                  ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Discount on invoice"),
              ]),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatNumber(
                          _vm.innerValue.discount,
                          _vm.$userInfo.locale
                        ),
                      },
                    }),
                  ])
                : _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          formats: "",
                          placeholder: "Discount applied on invoice",
                          precision: 2,
                          disabled: _vm.innerValue.readOnly || _vm.audanetLock,
                        },
                        model: {
                          value: _vm.innerValue.discount,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "discount", $$v)
                          },
                          expression: "innerValue.discount",
                        },
                      }),
                    ],
                    1
                  ),
            ]),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Est. Start & End Date"),
                ]),
                _vm.readOnlyView
                  ? _c("div", { staticClass: "control" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatDateLocale(
                              _vm.innerValue.jobStart,
                              _vm.$userInfo.locale
                            )
                          ) +
                            " - " +
                            _vm._s(
                              _vm.$filters.formatDateLocale(
                                _vm.innerValue.jobEnd,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]),
                    ])
                  : _c("v-date-picker", {
                      ref: "datepicker",
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        mode: "dateTime",
                        "minute-increment": 5,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        "select-attribute": _vm.selectDragAttribute,
                        "drag-attribute": _vm.selectDragAttribute,
                        "model-config": _vm.selectedJobStartEnd
                          ? {}
                          : _vm.modelConfig,
                        timezone: _vm.$filters.getIanaTimezone(),
                        "is-range": "",
                      },
                      on: {
                        drag: function ($event) {
                          return _vm.jobStartEndDragEvent($event)
                        },
                        input: function ($event) {
                          return _vm.jobStartEndInputEvent($event)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({
                              inputValue,
                              inputEvents,
                              isDragging,
                            }) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-body is-align-items-center",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "field mr-1 has-addons" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "control has-icons-left",
                                          },
                                          [
                                            _c(
                                              "input",
                                              _vm._g(
                                                {
                                                  staticClass: "input",
                                                  class: {
                                                    "has-text-grey": isDragging,
                                                  },
                                                  attrs: { readonly: "" },
                                                  domProps: {
                                                    value: inputValue.start,
                                                  },
                                                },
                                                inputEvents.start
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "icon is-small is-left",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-calendar mdi-18px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("span", { staticClass: "icon" }, [
                                      _c("i", {
                                        staticClass: "mdi mdi-arrow-right",
                                      }),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "field ml-1 has-addons" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "control has-icons-left",
                                          },
                                          [
                                            _c(
                                              "input",
                                              _vm._g(
                                                {
                                                  staticClass: "input",
                                                  class: {
                                                    "has-text-grey": isDragging,
                                                  },
                                                  attrs: { readonly: "" },
                                                  domProps: {
                                                    value: inputValue.end,
                                                  },
                                                },
                                                inputEvents.end
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "icon is-small is-left",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-calendar mdi-18px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "control" }, [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "button tooltip",
                                              attrs: {
                                                "data-tooltip": "Reset dates",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.resetJobStartEnd()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "icon" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "mdi mdi-close mdi-24px",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "day-popover",
                            fn: function ({ format }) {
                              return _vm.dragValue
                                ? _c("div", {}, [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            format(
                                              _vm.dragValue
                                                ? _vm.dragValue.start
                                                : _vm.selectedJobStartEnd.start,
                                              "MMM D"
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            format(
                                              _vm.dragValue
                                                ? _vm.dragValue.end
                                                : _vm.selectedJobStartEnd.end,
                                              "MMM D"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "center",
                                          "align-items": "center",
                                          "padding-top": "3px",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icon is-small",
                                            staticStyle: { color: "orange" },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-weather-sunny mdi-18px",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "padding-left": "3px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getNoOfDays(
                                                  _vm.dragValue
                                                    ? _vm.dragValue.start
                                                    : _vm.selectedJobStartEnd
                                                        .start,
                                                  _vm.dragValue
                                                    ? _vm.dragValue.end
                                                    : _vm.selectedJobStartEnd
                                                        .end
                                                )
                                              ) +
                                                " day" +
                                                _vm._s(
                                                  _vm.getNoOfDays(
                                                    _vm.dragValue
                                                      ? _vm.dragValue.start
                                                      : _vm.selectedJobStartEnd
                                                          .start,
                                                    _vm.dragValue
                                                      ? _vm.dragValue.end
                                                      : _vm.selectedJobStartEnd
                                                          .end
                                                  ) > 1
                                                    ? "s"
                                                    : ""
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e()
                            },
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.selectedJobStartEnd,
                        callback: function ($$v) {
                          _vm.selectedJobStartEnd = $$v
                        },
                        expression: "selectedJobStartEnd",
                      },
                    }),
              ],
              1
            ),
          ]),
        ]),
        !_vm.innerValue.isNew &&
        !_vm.readOnlyView &&
        _vm.$user.hasDelete(_vm.$route.meta.id)
          ? _c("div", [
              _c("div", { staticClass: "is-divider" }),
              _c("div", { staticClass: "buttons has-addons is-centered" }, [
                _c(
                  "span",
                  {
                    staticClass: "button",
                    class: {
                      "is-success is-selected": !_vm.innerValue.deleted,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleActive(true)
                      },
                    },
                  },
                  [_vm._m(4), _c("span", [_vm._v("Active")])]
                ),
                _c(
                  "span",
                  {
                    staticClass: "button",
                    class: { "is-danger is-selected": _vm.innerValue.deleted },
                    on: {
                      click: function ($event) {
                        return _vm.toggleActive(false)
                      },
                    },
                  },
                  [_vm._m(5), _c("span", [_vm._v("In-Active")])]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "cell" }, [
      _c(
        "article",
        { staticClass: "box" },
        [
          _c("p", { staticClass: "title" }, [_vm._v("Summary")]),
          _c("quote-detail-summary", {
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column py-2" }, [
      _c("label", { staticClass: "label mb-0" }, [_vm._v("Vehicle")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v("Hour")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v("Dollar")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }